import React from 'react';
import {
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	CustomInput,
	Form,
	Row,
	Col,
	Label,

} from 'reactstrap';
import { Button,Input,} from 'antd';
import {getData} from '../services/index';
import { message  } from 'antd';

import logo from '../assets/images/icon/logo.png';

class Login2 extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			user_id:0
		};	
	}
	
	
	componentWillMount() {
		
	}
	
	render() {
		return (
			<div></div>
			
		)
	}
}

export default Login2;
